import React, { PureComponent } from "react";
import styled from "styled-components";
import SelectorArrowIcon from "containers/assets/icon-arrow-select-solid.svg";

const TeamRolesSelectorContainer = styled.div`
  position: relative;
`;

const SelectedOptionWrapper = styled.div`
  border: 1px solid #D5D9DD;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);
  border-radius: 4px;
  width: 100%;
  padding: 2px 33px 2px 16px;
  color: rgba(0, 27, 59, 0.94);
  cursor: pointer;
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  background: #fff;

  ${p => (p.size && p.size === 'small') && `{
    padding: 2px 28.5px 2px 12px;
  }`}}
`;

const TeamRolesSelectorArrow = styled.div`
  width: 33px;
  height: 26px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
  align-items: center;

  img {
    width: 10px;
    margin-left: 8px;
  }

  ${p => (p.size && p.size === 'small') && `{
    width: 28.5px;

    img {
      width: 7px;
      margin-left: 6.5px;
    }
  }`}}
`;

const TeamRolesSelectorItemsWrapper = styled.div`
  z-index: 1;
  position: absolute;
  display: none;
  left: 0;
  right: 0;
  width: 100%;

  ${p => p.dropUp
    ? `
    bottom: 100%;
    margin-bottom: 4px;
  `
    : `
    top: 100%;
    margin-top: 4px;
  `}

  ${p =>
    p.isShown &&
    `
    display: block;
  `}
`;

const TeamRolesSelectorItems = styled.ul`
  width: 100%;
  border: 1px solid #D5D9DD;
  border-radius: 4px;
  list-style: none;
  color: rgba(0, 27, 59, 0.94);
  background-color: #fff;
  padding: 0;
  max-height: 300px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 3px;
  }
   
  &::-webkit-scrollbar-thumb {
    background: #D5D9DD; 
  }

  li {
    cursor: pointer;
    padding: 2px 16px;
  }

  li:hover {
    background: #FAFBFD;
  }
`;

class TeamRolesSelector extends PureComponent {
  constructor(props) {
    super(props);

    this.currentRef = null;
    this.currentRef2 = null;

    this.state = {
      menuShown: false
    };
  }

  componentDidMount() {
    if (window) {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    if (window) {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }

  handleClickOutside = e => {
    let clicked1 = false;
    if (this.currentRef && this.currentRef.contains(e.target)) {
      clicked1 = true;
    }

    let clicked2 = false;
    if (this.currentRef2 && this.currentRef2.contains(e.target)) {
      clicked2 = true;
    }

    if (!clicked1 && !clicked2) {
      this.setState({
        menuShown: false
      });
    }
  };

  toggleMenu = () => {
    this.setState({
      menuShown: !this.state.menuShown
    });
  };

  render() {
    const { menuShown } = this.state;
    const {
      options,
      onSelectorChange,
      selectedOptionId,
      size,
      dropUp
    } = this.props;

    return (
      <TeamRolesSelectorContainer>
        <SelectedOptionWrapper
          innerRef={node => (this.currentRef = node)}
          onClick={this.toggleMenu}
          size={size}
        >
          <span>
            {
              selectedOptionId
                ? options[' ' + selectedOptionId]
                  ? options[' ' + selectedOptionId]
                  : options[selectedOptionId]
                : Object.values(options)[0]
            }
          </span>
          <TeamRolesSelectorArrow size={size}>
            <img src={SelectorArrowIcon} alt="arrow" />
          </TeamRolesSelectorArrow>
        </SelectedOptionWrapper>
        <TeamRolesSelectorItemsWrapper
          innerRef={node => (this.currentRef2 = node)}
          isShown={menuShown}
          dropUp={dropUp}
        >
          <TeamRolesSelectorItems>
            {
              Object.keys(options).map((option_id, index) => (
                <li
                  onClick={() => {
                    if (option_id !== selectedOptionId)
                      onSelectorChange(option_id);

                    this.toggleMenu();
                  }}
                  value={option_id}
                  key={index}
                >
                  {options[option_id]}
                </li>
              ))
            }
          </TeamRolesSelectorItems>
        </TeamRolesSelectorItemsWrapper>
      </TeamRolesSelectorContainer>
    );
  }
}

export default TeamRolesSelector;



// WEBPACK FOOTER //
// ./src/instructor/components/teams-roles/selector.js